"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports.default = void 0;
var _recommendationActions = require("../recommendation/recommendationActions");
var _upsellActions = require("./upsellActions");
const initialState = {
  categories: [],
  selectedUpsellProducts: {},
  displayedUpsellProductDetails: {},
  connectivityPlan: {
    offering: {},
    selected: false
  },
  slidersValues: {}
};
exports.initialState = initialState;
const upsellReducer = function () {
  var _state$selectedUpsell;
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  let {
    type,
    payload
  } = arguments.length > 1 ? arguments[1] : undefined;
  switch (type) {
    case _upsellActions.SET_UPSELL_CATEGORIES:
      {
        const selectedUpsellProductsObject = {};
        payload.upsellProductCategories.forEach(category => {
          selectedUpsellProductsObject[category] = [];
        });
        return {
          ...state,
          selectedUpsellProducts: selectedUpsellProductsObject,
          categories: payload.upsellProductCategories
        };
      }
    case _upsellActions.ADD_SELECTED_UPSELL_PRODUCT:
      return {
        ...state,
        selectedUpsellProducts: {
          ...state.selectedUpsellProducts,
          [payload.category]: [...new Set([...state.selectedUpsellProducts[payload.category], payload.id])]
        }
      };
    case _upsellActions.REMOVE_SELECTED_UPSELL_PRODUCT:
      return {
        ...state,
        selectedUpsellProducts: {
          ...state.selectedUpsellProducts,
          [payload.category]: (_state$selectedUpsell = state.selectedUpsellProducts[payload.category]) === null || _state$selectedUpsell === void 0 ? void 0 : _state$selectedUpsell.filter(product => product !== payload.id)
        }
      };
    case _recommendationActions.UPDATE_SELECTED_HANDSET:
    case _upsellActions.CLEAR_SELECTED_UPSELL_PRODUCT:
      {
        const selectedUpsellProductsObject = {};
        state.categories.forEach(category => {
          selectedUpsellProductsObject[category] = [];
        });
        return {
          ...state,
          selectedUpsellProducts: selectedUpsellProductsObject,
          connectivityPlan: {
            ...state.connectivityPlan,
            selected: false
          }
        };
      }
    case _upsellActions.ADD_DISPLAYED_UPSELL_PRODUCT_DETAILS:
      return {
        ...state,
        displayedUpsellProductDetails: payload.product
      };
    case _upsellActions.REMOVE_DISPLAYED_UPSELL_PRODUCT_DETAILS:
      return {
        ...state,
        displayedUpsellProductDetails: {}
      };
    case _upsellActions.SET_CONNECTIVITY_PLAN:
      return {
        ...state,
        connectivityPlan: {
          ...state.connectivityPlan,
          offering: payload.product
        }
      };
    case _upsellActions.SET_IS_CONNECTIVITY_PLAN_SELECTED:
      return {
        ...state,
        connectivityPlan: {
          ...state.connectivityPlan,
          selected: payload.selected
        }
      };
    case _upsellActions.SET_SLIDERS_VALUES:
      return {
        ...state,
        slidersValues: {
          ...state.slidersValues,
          [payload.id]: {
            ...state.slidersValues[payload.id],
            ...payload
          }
        }
      };
    case _upsellActions.CLEAR_SLIDERS_VALUES:
      return {
        ...state,
        slidersValues: {}
      };
    default:
      return state;
  }
};
var _default = upsellReducer;
exports.default = _default;